import { Popper as MUIPopper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import cx from 'classnames';

const useStyles = makeStyles(() => ({
  root: {
    zIndex: 10000,
    boxShadow:
      '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
    maxHeight: 'calc(100dvh - 80px)',
    background: 'white',
    overflow: 'hidden',
    borderRadius: '0px 8px 8px 8px',
    maxWidth: '416px',
  },
}));

const Popper = ({ children, className, onClose, ...rest }) => {
  const classes = useStyles();

  return (
    <MUIPopper
      className={cx(classes.root, className)}
      disablePortal
      transition
      placement="bottom-end"
      onClose={onClose}
      {...rest}
    >
      <ClickAwayListener mouseEvent="onMouseUp" onClickAway={onClose}>
        {children}
      </ClickAwayListener>
    </MUIPopper>
  );
};

export default Popper;
